import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { Observable } from 'rxjs';

import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';
import { Action, ActionFilters } from '../../../commons/models/action.model';

export type ActionsColumn = "id" | "date" | "description" | "offer" | "businessOpportunity" | "actions";

@Component({
  selector: 'action-list',
  templateUrl: './action-list.component.html',
  styleUrls: ['./action-list.component.scss'],
})
export class ActionListComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input()
  actions: Observable<Action[]>;

  @Input()
  defaultFilters: ActionFilters;

  pageSizeOptions = PAGE_SIZE_OPTIONS;
  expandedElement: Action | null;

  @Input()
  total: Observable<number>;
  @Input()
  displayedColumns: ActionsColumn[] = ["id", "date", "businessOpportunity", "offer", "description", "actions"];

  @Input()
  canAdd: boolean;
  @Input()
  canEdit: boolean;
  @Input()
  canSelect: boolean;

  @Output()
  onLoad: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
  @Output()
  onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output()
  onFilterChange: EventEmitter<ActionFilters> = new EventEmitter<ActionFilters>();

  @Output()
  onSelectAction: EventEmitter<Action> = new EventEmitter<Action>();
  @Output()
  onAddAction: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onEditAction: EventEmitter<Action> = new EventEmitter<Action>();
  @Output()
  onShowAction: EventEmitter<Action> = new EventEmitter<Action>();

  constructor() { }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort) => {
      this.onSortChange.emit(sort);
    });
    this.paginator.page.subscribe((pageEvent) => {
      this.onPageChange.emit(pageEvent);
    });
  }

  addAction() {
    this.onAddAction.emit();
  }

  editAction(account: Action) {
    this.onEditAction.emit(account);
  }

  selectAction(account: Action) {
    this.onSelectAction.emit(account);
  }

  onFilter(filters: ActionFilters) {
    this.paginator.firstPage();
    this.onFilterChange.emit(filters);
  }

  showAction(activityList: Action) {
    this.onShowAction.emit(activityList);
  }
}
